import {
  SimpleGrid,
  Text,
  Container,
  Center,
  Heading,
  Button,
  useBreakpointValue,
} from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import EmptyFancyBearCard from "components/EmptyFancyBearCard";
import useAssets from "hooks/useAssets";
import useTranslate from "hooks/useTranslate";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import FancyBearCard from "./FancyBearCard";
import { fancyBearsOpenSeaUrl } from "config";

const FancyBearsContainer = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { fancyBearsInWallet } = useAssets();

  const buttonSize = useBreakpointValue({
    base: "xs",
    sm: "sm",
  });

  const handleClick = useCallback(
    (tokenId: number) => {
      navigate(`/bears/${tokenId}`);
    },
    [navigate]
  );

  if (fancyBearsInWallet === undefined) {
    return (
      <Center h="52">
        <BoldSpinner size="xl" />
      </Center>
    );
  }

  return (
    <Container mt="0">
      <Heading fontSize="2xl" mb="5">
        {translate("fancyBears:title", { count: fancyBearsInWallet.length })}
      </Heading>

      <SimpleGrid columns={2} spacing="4" w="full">
        {fancyBearsInWallet
          .sort((a, b) => b - a)
          .map((tokenId) => (
            <FancyBearCard
              key={tokenId}
              tokenId={tokenId}
              onClick={() => handleClick(tokenId)}
            >
              <Text fontWeight="600">#{tokenId}</Text>
            </FancyBearCard>
          ))}

        <EmptyFancyBearCard position="relative">
          <Text fontWeight="semibold">#???</Text>

          <Center
            flexDirection="column"
            position="absolute"
            w="full"
            h="full"
            px="3"
            textAlign="center"
            zIndex={1}
            top="0"
            left="0"
          >
            <Text
              fontWeight="semibold"
              mb="4"
              mt="10%"
              maxW="10rem"
              fontSize={{ base: "sm", sm: "md" }}
              lineHeight="shorter"
            >
              {translate("fancyBears:empty:title")}
            </Text>

            <Button
              as="a"
              href={fancyBearsOpenSeaUrl}
              target="_blank"
              rel="noreferrer"
              flexShrink="0"
              size={buttonSize}
              cursor="pointer"
              colorScheme="dark"
            >
              {translate("common:buyOnOpenSea")}
            </Button>
          </Center>
        </EmptyFancyBearCard>
      </SimpleGrid>
    </Container>
  );
};

export default FancyBearsContainer;
